import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H7 from 'UIComponents/elements/headings/H7';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import classNames from '../../utils/classNames';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import CodeSplitEnvWrapper from './env/CodeSplitEnvWrapper';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Section } from './SharedComponents';
const PhoneSupportWrapper = styled.div.withConfig({
  displayName: "PhoneSupport__PhoneSupportWrapper",
  componentId: "ssx8uy-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;", ""], breakpoint.phone(_t || (_t = _`
    padding: 60px 20px 0;
  `)));
const PhoneSupportContainer = styled.div.withConfig({
  displayName: "PhoneSupport__PhoneSupportContainer",
  componentId: "ssx8uy-1"
})(["border:", ";border-radius:200px;margin:0 auto;text-align:center;padding:16px 44px;"], ({
  border
}) => border ? `1px ${BATTLESHIP} solid` : 'none');
const PhoneNumberContainer = styled.div.withConfig({
  displayName: "PhoneSupport__PhoneNumberContainer",
  componentId: "ssx8uy-2"
})(["display:inline-flex;align-items:flex-start;", " .phone-heading{font-size:1.25rem;font-weight:600;}"], breakpoint.tablet(_t2 || (_t2 = _`
    display: block;
    white-space: nowrap;
  `)));
const StyledHeader = styled(H7).withConfig({
  displayName: "PhoneSupport__StyledHeader",
  componentId: "ssx8uy-3"
})(["line-height:1.8;margin-bottom:0.75em;text-align:center;font-size:1.15em;.phone-support-header{display:block;}"]);
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "PhoneSupport__StyledIcon",
  componentId: "ssx8uy-4"
})(["margin-right:10px;font-size:15px;", ""], breakpoint.tablet(_t3 || (_t3 = _`
    font-size: 24px;
  `)));

const PhoneSupport = ({
  phoneSourceId,
  border = true,
  showCopy = true,
  screen,
  className
}) => {
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsxs(PhoneSupportWrapper, {
      className: classNames(className),
      children: [showCopy && /*#__PURE__*/_jsx(StyledHeader, {
        "data-selenium-id": "phone-support-header",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.needHelp",
          className: "phone-support-header"
        })
      }), /*#__PURE__*/_jsx(PhoneSupportContainer, {
        className: "phone-support-container",
        border: border,
        children: /*#__PURE__*/_jsxs(PhoneNumberContainer, {
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            name: "calling"
          }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
            authedComponentLoader: () => import(
            /* webpackChunkName: "authed-chunk" */
            'pricing-pages-ui/components/common/phone-numbers/AuthedPhoneNumber'),
            publicComponentLoader: () => import(
            /* webpackChunkName: "public-chunk" */
            'pricing-pages-ui/components/common/phone-numbers/PublicPhoneNumber'),
            authedComponentProps: {
              phoneSourceId,
              screen
            },
            publicComponentProps: {
              phoneSourceId,
              screen
            }
          })]
        })
      })]
    })
  });
};

export default PhoneSupport;